import { useMemo } from 'react';
import { useLegWarnings, UseLegWarningsParams } from '@lp/features/RoutePlanner/hooks/useLegWarnings';
import { useDriveTripWarnings } from '@lp/features/RoutePlanner/hooks/useGroundTripWarnings';
import { TmdxDriveAffiliateGroundLeg, TmdxDriveTedsGroundLeg } from '@/api/apis/route';
import { LegWarningsList } from './LegWarningsList';

type GroundTripLegWarningsProps = Omit<UseLegWarningsParams, 'leg'> & {
  leg: TmdxDriveAffiliateGroundLeg | TmdxDriveTedsGroundLeg;
};

export const GroundTripLegWarnings = ({ leg, prevLeg, segment }: GroundTripLegWarningsProps) => {
  const groundTripWarnings = useDriveTripWarnings(leg);
  const legWarnings = useLegWarnings({ leg, prevLeg, segment });

  const warnings = useMemo(() => {
    return [...legWarnings, ...groundTripWarnings];
  }, [groundTripWarnings, legWarnings]);

  return <LegWarningsList warnings={warnings} />;
};
